/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const network = ($root.network = (() => {
  /**
   * Namespace network.
   * @exports network
   * @namespace
   */
  const network = {};

  network.monitor = (function () {
    /**
     * Namespace monitor.
     * @memberof network
     * @namespace
     */
    const monitor = {};

    monitor.ElementResponseRoot = (function () {
      /**
       * Properties of an ElementResponseRoot.
       * @memberof network.monitor
       * @interface IElementResponseRoot
       * @property {Array.<network.monitor.IElement>|null} [elementosResponse] ElementResponseRoot elementosResponse
       * @property {string|null} [dataColeta] ElementResponseRoot dataColeta
       */

      /**
       * Constructs a new ElementResponseRoot.
       * @memberof network.monitor
       * @classdesc Represents an ElementResponseRoot.
       * @implements IElementResponseRoot
       * @constructor
       * @param {network.monitor.IElementResponseRoot=} [properties] Properties to set
       */
      function ElementResponseRoot(properties) {
        this.elementosResponse = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * ElementResponseRoot elementosResponse.
       * @member {Array.<network.monitor.IElement>} elementosResponse
       * @memberof network.monitor.ElementResponseRoot
       * @instance
       */
      ElementResponseRoot.prototype.elementosResponse = $util.emptyArray;

      /**
       * ElementResponseRoot dataColeta.
       * @member {string} dataColeta
       * @memberof network.monitor.ElementResponseRoot
       * @instance
       */
      ElementResponseRoot.prototype.dataColeta = "";

      /**
       * Creates a new ElementResponseRoot instance using the specified properties.
       * @function create
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {network.monitor.IElementResponseRoot=} [properties] Properties to set
       * @returns {network.monitor.ElementResponseRoot} ElementResponseRoot instance
       */
      ElementResponseRoot.create = function create(properties) {
        return new ElementResponseRoot(properties);
      };

      /**
       * Encodes the specified ElementResponseRoot message. Does not implicitly {@link network.monitor.ElementResponseRoot.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {network.monitor.IElementResponseRoot} message ElementResponseRoot message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ElementResponseRoot.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.elementosResponse != null &&
          message.elementosResponse.length
        )
          for (let i = 0; i < message.elementosResponse.length; ++i)
            $root.network.monitor.Element.encode(
              message.elementosResponse[i],
              writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
            ).ldelim();
        if (
          message.dataColeta != null &&
          Object.hasOwnProperty.call(message, "dataColeta")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.dataColeta);
        return writer;
      };

      /**
       * Encodes the specified ElementResponseRoot message, length delimited. Does not implicitly {@link network.monitor.ElementResponseRoot.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {network.monitor.IElementResponseRoot} message ElementResponseRoot message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ElementResponseRoot.encodeDelimited = function encodeDelimited(
        message,
        writer,
      ) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an ElementResponseRoot message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.ElementResponseRoot} ElementResponseRoot
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ElementResponseRoot.decode = function decode(
        reader,
        length,
        error,
        long,
      ) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.ElementResponseRoot();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              if (!(
                message.elementosResponse && message.elementosResponse.length
              ))
                message.elementosResponse = [];
              message.elementosResponse.push(
                $root.network.monitor.Element.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 2: {
              message.dataColeta = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an ElementResponseRoot message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.ElementResponseRoot} ElementResponseRoot
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ElementResponseRoot.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an ElementResponseRoot message.
       * @function verify
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ElementResponseRoot.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (
          message.elementosResponse != null &&
          message.hasOwnProperty("elementosResponse")
        ) {
          if (!Array.isArray(message.elementosResponse))
            return "elementosResponse: array expected";
          for (let i = 0; i < message.elementosResponse.length; ++i) {
            let error = $root.network.monitor.Element.verify(
              message.elementosResponse[i],
              long + 1,
            );
            if (error) return "elementosResponse." + error;
          }
        }
        if (message.dataColeta != null && message.hasOwnProperty("dataColeta"))
          if (!$util.isString(message.dataColeta))
            return "dataColeta: string expected";
        return null;
      };

      /**
       * Creates an ElementResponseRoot message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.ElementResponseRoot} ElementResponseRoot
       */
      ElementResponseRoot.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.ElementResponseRoot)
          return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.ElementResponseRoot();
        if (object.elementosResponse) {
          if (!Array.isArray(object.elementosResponse))
            throw TypeError(
              ".network.monitor.ElementResponseRoot.elementosResponse: array expected",
            );
          message.elementosResponse = [];
          for (let i = 0; i < object.elementosResponse.length; ++i) {
            if (typeof object.elementosResponse[i] !== "object")
              throw TypeError(
                ".network.monitor.ElementResponseRoot.elementosResponse: object expected",
              );
            message.elementosResponse[i] =
              $root.network.monitor.Element.fromObject(
                object.elementosResponse[i],
                long + 1,
              );
          }
        }
        if (object.dataColeta != null)
          message.dataColeta = String(object.dataColeta);
        return message;
      };

      /**
       * Creates a plain object from an ElementResponseRoot message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {network.monitor.ElementResponseRoot} message ElementResponseRoot
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ElementResponseRoot.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.arrays || options.defaults) object.elementosResponse = [];
        if (options.defaults) object.dataColeta = "";
        if (message.elementosResponse && message.elementosResponse.length) {
          object.elementosResponse = [];
          for (let j = 0; j < message.elementosResponse.length; ++j)
            object.elementosResponse[j] =
              $root.network.monitor.Element.toObject(
                message.elementosResponse[j],
                options,
              );
        }
        if (message.dataColeta != null && message.hasOwnProperty("dataColeta"))
          object.dataColeta = message.dataColeta;
        return object;
      };

      /**
       * Converts this ElementResponseRoot to JSON.
       * @function toJSON
       * @memberof network.monitor.ElementResponseRoot
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ElementResponseRoot.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for ElementResponseRoot
       * @function getTypeUrl
       * @memberof network.monitor.ElementResponseRoot
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      ElementResponseRoot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.ElementResponseRoot";
      };

      return ElementResponseRoot;
    })();

    monitor.Element = (function () {
      /**
       * Properties of an Element.
       * @memberof network.monitor
       * @interface IElement
       * @property {string|null} [id] Element id
       * @property {Array.<network.monitor.IConnection>|null} [connections] Element connections
       * @property {Array.<network.monitor.IHost>|null} [hosts] Element hosts
       * @property {Array.<network.monitor.IAlert>|null} [alerts] Element alerts
       * @property {network.monitor.IConfig|null} [config] Element config
       * @property {Array.<string>|null} [tags] Element tags
       */

      /**
       * Constructs a new Element.
       * @memberof network.monitor
       * @classdesc Represents an Element.
       * @implements IElement
       * @constructor
       * @param {network.monitor.IElement=} [properties] Properties to set
       */
      function Element(properties) {
        this.connections = [];
        this.hosts = [];
        this.alerts = [];
        this.tags = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * Element id.
       * @member {string} id
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.id = "";

      /**
       * Element connections.
       * @member {Array.<network.monitor.IConnection>} connections
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.connections = $util.emptyArray;

      /**
       * Element hosts.
       * @member {Array.<network.monitor.IHost>} hosts
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.hosts = $util.emptyArray;

      /**
       * Element alerts.
       * @member {Array.<network.monitor.IAlert>} alerts
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.alerts = $util.emptyArray;

      /**
       * Element config.
       * @member {network.monitor.IConfig|null|undefined} config
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.config = null;

      /**
       * Element tags.
       * @member {Array.<string>} tags
       * @memberof network.monitor.Element
       * @instance
       */
      Element.prototype.tags = $util.emptyArray;

      /**
       * Creates a new Element instance using the specified properties.
       * @function create
       * @memberof network.monitor.Element
       * @static
       * @param {network.monitor.IElement=} [properties] Properties to set
       * @returns {network.monitor.Element} Element instance
       */
      Element.create = function create(properties) {
        return new Element(properties);
      };

      /**
       * Encodes the specified Element message. Does not implicitly {@link network.monitor.Element.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.Element
       * @static
       * @param {network.monitor.IElement} message Element message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Element.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.connections != null && message.connections.length)
          for (let i = 0; i < message.connections.length; ++i)
            $root.network.monitor.Connection.encode(
              message.connections[i],
              writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
            ).ldelim();
        if (message.hosts != null && message.hosts.length)
          for (let i = 0; i < message.hosts.length; ++i)
            $root.network.monitor.Host.encode(
              message.hosts[i],
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
            ).ldelim();
        if (message.alerts != null && message.alerts.length)
          for (let i = 0; i < message.alerts.length; ++i)
            $root.network.monitor.Alert.encode(
              message.alerts[i],
              writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
            ).ldelim();
        if (
          message.config != null &&
          Object.hasOwnProperty.call(message, "config")
        )
          $root.network.monitor.Config.encode(
            message.config,
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork(),
          ).ldelim();
        if (message.tags != null && message.tags.length)
          for (let i = 0; i < message.tags.length; ++i)
            writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.tags[i]);
        return writer;
      };

      /**
       * Encodes the specified Element message, length delimited. Does not implicitly {@link network.monitor.Element.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.Element
       * @static
       * @param {network.monitor.IElement} message Element message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Element.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Element message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.Element
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.Element} Element
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Element.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.Element();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.id = reader.string();
              break;
            }
            case 2: {
              if (!(message.connections && message.connections.length))
                message.connections = [];
              message.connections.push(
                $root.network.monitor.Connection.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 3: {
              if (!(message.hosts && message.hosts.length)) message.hosts = [];
              message.hosts.push(
                $root.network.monitor.Host.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 4: {
              if (!(message.alerts && message.alerts.length))
                message.alerts = [];
              message.alerts.push(
                $root.network.monitor.Alert.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 5: {
              message.config = $root.network.monitor.Config.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 6: {
              if (!(message.tags && message.tags.length)) message.tags = [];
              message.tags.push(reader.string());
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Element message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.Element
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.Element} Element
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Element.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Element message.
       * @function verify
       * @memberof network.monitor.Element
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Element.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.id != null && message.hasOwnProperty("id"))
          if (!$util.isString(message.id)) return "id: string expected";
        if (
          message.connections != null &&
          message.hasOwnProperty("connections")
        ) {
          if (!Array.isArray(message.connections))
            return "connections: array expected";
          for (let i = 0; i < message.connections.length; ++i) {
            let error = $root.network.monitor.Connection.verify(
              message.connections[i],
              long + 1,
            );
            if (error) return "connections." + error;
          }
        }
        if (message.hosts != null && message.hasOwnProperty("hosts")) {
          if (!Array.isArray(message.hosts)) return "hosts: array expected";
          for (let i = 0; i < message.hosts.length; ++i) {
            let error = $root.network.monitor.Host.verify(
              message.hosts[i],
              long + 1,
            );
            if (error) return "hosts." + error;
          }
        }
        if (message.alerts != null && message.hasOwnProperty("alerts")) {
          if (!Array.isArray(message.alerts)) return "alerts: array expected";
          for (let i = 0; i < message.alerts.length; ++i) {
            let error = $root.network.monitor.Alert.verify(
              message.alerts[i],
              long + 1,
            );
            if (error) return "alerts." + error;
          }
        }
        if (message.config != null && message.hasOwnProperty("config")) {
          let error = $root.network.monitor.Config.verify(
            message.config,
            long + 1,
          );
          if (error) return "config." + error;
        }
        if (message.tags != null && message.hasOwnProperty("tags")) {
          if (!Array.isArray(message.tags)) return "tags: array expected";
          for (let i = 0; i < message.tags.length; ++i)
            if (!$util.isString(message.tags[i]))
              return "tags: string[] expected";
        }
        return null;
      };

      /**
       * Creates an Element message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.Element
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.Element} Element
       */
      Element.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.Element) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.Element();
        if (object.id != null) message.id = String(object.id);
        if (object.connections) {
          if (!Array.isArray(object.connections))
            throw TypeError(
              ".network.monitor.Element.connections: array expected",
            );
          message.connections = [];
          for (let i = 0; i < object.connections.length; ++i) {
            if (typeof object.connections[i] !== "object")
              throw TypeError(
                ".network.monitor.Element.connections: object expected",
              );
            message.connections[i] =
              $root.network.monitor.Connection.fromObject(
                object.connections[i],
                long + 1,
              );
          }
        }
        if (object.hosts) {
          if (!Array.isArray(object.hosts))
            throw TypeError(".network.monitor.Element.hosts: array expected");
          message.hosts = [];
          for (let i = 0; i < object.hosts.length; ++i) {
            if (typeof object.hosts[i] !== "object")
              throw TypeError(
                ".network.monitor.Element.hosts: object expected",
              );
            message.hosts[i] = $root.network.monitor.Host.fromObject(
              object.hosts[i],
              long + 1,
            );
          }
        }
        if (object.alerts) {
          if (!Array.isArray(object.alerts))
            throw TypeError(".network.monitor.Element.alerts: array expected");
          message.alerts = [];
          for (let i = 0; i < object.alerts.length; ++i) {
            if (typeof object.alerts[i] !== "object")
              throw TypeError(
                ".network.monitor.Element.alerts: object expected",
              );
            message.alerts[i] = $root.network.monitor.Alert.fromObject(
              object.alerts[i],
              long + 1,
            );
          }
        }
        if (object.config != null) {
          if (typeof object.config !== "object")
            throw TypeError(".network.monitor.Element.config: object expected");
          message.config = $root.network.monitor.Config.fromObject(
            object.config,
            long + 1,
          );
        }
        if (object.tags) {
          if (!Array.isArray(object.tags))
            throw TypeError(".network.monitor.Element.tags: array expected");
          message.tags = [];
          for (let i = 0; i < object.tags.length; ++i)
            message.tags[i] = String(object.tags[i]);
        }
        return message;
      };

      /**
       * Creates a plain object from an Element message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.Element
       * @static
       * @param {network.monitor.Element} message Element
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Element.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.connections = [];
          object.hosts = [];
          object.alerts = [];
          object.tags = [];
        }
        if (options.defaults) {
          object.id = "";
          object.config = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.connections && message.connections.length) {
          object.connections = [];
          for (let j = 0; j < message.connections.length; ++j)
            object.connections[j] = $root.network.monitor.Connection.toObject(
              message.connections[j],
              options,
            );
        }
        if (message.hosts && message.hosts.length) {
          object.hosts = [];
          for (let j = 0; j < message.hosts.length; ++j)
            object.hosts[j] = $root.network.monitor.Host.toObject(
              message.hosts[j],
              options,
            );
        }
        if (message.alerts && message.alerts.length) {
          object.alerts = [];
          for (let j = 0; j < message.alerts.length; ++j)
            object.alerts[j] = $root.network.monitor.Alert.toObject(
              message.alerts[j],
              options,
            );
        }
        if (message.config != null && message.hasOwnProperty("config"))
          object.config = $root.network.monitor.Config.toObject(
            message.config,
            options,
          );
        if (message.tags && message.tags.length) {
          object.tags = [];
          for (let j = 0; j < message.tags.length; ++j)
            object.tags[j] = message.tags[j];
        }
        return object;
      };

      /**
       * Converts this Element to JSON.
       * @function toJSON
       * @memberof network.monitor.Element
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Element.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for Element
       * @function getTypeUrl
       * @memberof network.monitor.Element
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      Element.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.Element";
      };

      return Element;
    })();

    monitor.Connection = (function () {
      /**
       * Properties of a Connection.
       * @memberof network.monitor
       * @interface IConnection
       * @property {string|null} [id] Connection id
       * @property {string|null} ["interface"] Connection interface
       * @property {Array.<network.monitor.IItemData>|null} [itensData] Connection itensData
       * @property {number|Long|null} [rx_traffic] Connection rx_traffic
       * @property {number|null} [tx_power] Connection tx_power
       * @property {number|null} [rx_power] Connection rx_power
       * @property {number|Long|null} [tx_traffic] Connection tx_traffic
       * @property {number|Long|null} [capacidade_zabbix] Connection capacidade_zabbix
       * @property {number|null} [status] Connection status
       * @property {network.monitor.IStatusColor|null} [corTraffic] Connection corTraffic
       * @property {network.monitor.IStatusColor|null} [corPower] Connection corPower
       * @property {number|null} [percentTraffic] Connection percentTraffic
       * @property {number|null} [qualityPower] Connection qualityPower
       * @property {boolean|null} [isDown] Connection isDown
       * @property {network.monitor.IStatusColor|null} [corTrafficTx] Connection corTrafficTx
       * @property {network.monitor.IStatusColor|null} [corTrafficRx] Connection corTrafficRx
       * @property {network.monitor.IStatusColor|null} [corPowerTx] Connection corPowerTx
       * @property {network.monitor.IStatusColor|null} [corPowerRx] Connection corPowerRx
       * @property {number|null} [percentTrafficTx] Connection percentTrafficTx
       * @property {number|null} [percentTrafficRx] Connection percentTrafficRx
       * @property {number|null} [qualityPowerTx] Connection qualityPowerTx
       * @property {number|null} [qualityPowerRx] Connection qualityPowerRx
       */

      /**
       * Constructs a new Connection.
       * @memberof network.monitor
       * @classdesc Represents a Connection.
       * @implements IConnection
       * @constructor
       * @param {network.monitor.IConnection=} [properties] Properties to set
       */
      function Connection(properties) {
        this.itensData = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * Connection id.
       * @member {string} id
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.id = "";

      /**
       * Connection interface.
       * @member {string} interface
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype["interface"] = "";

      /**
       * Connection itensData.
       * @member {Array.<network.monitor.IItemData>} itensData
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.itensData = $util.emptyArray;

      /**
       * Connection rx_traffic.
       * @member {number|Long} rx_traffic
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.rx_traffic = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Connection tx_power.
       * @member {number} tx_power
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.tx_power = 0;

      /**
       * Connection rx_power.
       * @member {number} rx_power
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.rx_power = 0;

      /**
       * Connection tx_traffic.
       * @member {number|Long} tx_traffic
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.tx_traffic = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Connection capacidade_zabbix.
       * @member {number|Long} capacidade_zabbix
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.capacidade_zabbix = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Connection status.
       * @member {number} status
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.status = 0;

      /**
       * Connection corTraffic.
       * @member {network.monitor.IStatusColor|null|undefined} corTraffic
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corTraffic = null;

      /**
       * Connection corPower.
       * @member {network.monitor.IStatusColor|null|undefined} corPower
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corPower = null;

      /**
       * Connection percentTraffic.
       * @member {number} percentTraffic
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.percentTraffic = 0;

      /**
       * Connection qualityPower.
       * @member {number} qualityPower
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.qualityPower = 0;

      /**
       * Connection isDown.
       * @member {boolean} isDown
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.isDown = false;

      /**
       * Connection corTrafficTx.
       * @member {network.monitor.IStatusColor|null|undefined} corTrafficTx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corTrafficTx = null;

      /**
       * Connection corTrafficRx.
       * @member {network.monitor.IStatusColor|null|undefined} corTrafficRx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corTrafficRx = null;

      /**
       * Connection corPowerTx.
       * @member {network.monitor.IStatusColor|null|undefined} corPowerTx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corPowerTx = null;

      /**
       * Connection corPowerRx.
       * @member {network.monitor.IStatusColor|null|undefined} corPowerRx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.corPowerRx = null;

      /**
       * Connection percentTrafficTx.
       * @member {number} percentTrafficTx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.percentTrafficTx = 0;

      /**
       * Connection percentTrafficRx.
       * @member {number} percentTrafficRx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.percentTrafficRx = 0;

      /**
       * Connection qualityPowerTx.
       * @member {number} qualityPowerTx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.qualityPowerTx = 0;

      /**
       * Connection qualityPowerRx.
       * @member {number} qualityPowerRx
       * @memberof network.monitor.Connection
       * @instance
       */
      Connection.prototype.qualityPowerRx = 0;

      /**
       * Creates a new Connection instance using the specified properties.
       * @function create
       * @memberof network.monitor.Connection
       * @static
       * @param {network.monitor.IConnection=} [properties] Properties to set
       * @returns {network.monitor.Connection} Connection instance
       */
      Connection.create = function create(properties) {
        return new Connection(properties);
      };

      /**
       * Encodes the specified Connection message. Does not implicitly {@link network.monitor.Connection.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.Connection
       * @static
       * @param {network.monitor.IConnection} message Connection message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Connection.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (
          message["interface"] != null &&
          Object.hasOwnProperty.call(message, "interface")
        )
          writer
            .uint32(/* id 2, wireType 2 =*/ 18)
            .string(message["interface"]);
        if (message.itensData != null && message.itensData.length)
          for (let i = 0; i < message.itensData.length; ++i)
            $root.network.monitor.ItemData.encode(
              message.itensData[i],
              writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
            ).ldelim();
        if (
          message.rx_traffic != null &&
          Object.hasOwnProperty.call(message, "rx_traffic")
        )
          writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.rx_traffic);
        if (
          message.tx_power != null &&
          Object.hasOwnProperty.call(message, "tx_power")
        )
          writer.uint32(/* id 5, wireType 1 =*/ 41).double(message.tx_power);
        if (
          message.rx_power != null &&
          Object.hasOwnProperty.call(message, "rx_power")
        )
          writer.uint32(/* id 6, wireType 1 =*/ 49).double(message.rx_power);
        if (
          message.tx_traffic != null &&
          Object.hasOwnProperty.call(message, "tx_traffic")
        )
          writer.uint32(/* id 7, wireType 0 =*/ 56).int64(message.tx_traffic);
        if (
          message.capacidade_zabbix != null &&
          Object.hasOwnProperty.call(message, "capacidade_zabbix")
        )
          writer
            .uint32(/* id 8, wireType 0 =*/ 64)
            .int64(message.capacidade_zabbix);
        if (
          message.status != null &&
          Object.hasOwnProperty.call(message, "status")
        )
          writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.status);
        if (
          message.corTraffic != null &&
          Object.hasOwnProperty.call(message, "corTraffic")
        )
          $root.network.monitor.StatusColor.encode(
            message.corTraffic,
            writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
          ).ldelim();
        if (
          message.corPower != null &&
          Object.hasOwnProperty.call(message, "corPower")
        )
          $root.network.monitor.StatusColor.encode(
            message.corPower,
            writer.uint32(/* id 11, wireType 2 =*/ 90).fork(),
          ).ldelim();
        if (
          message.percentTraffic != null &&
          Object.hasOwnProperty.call(message, "percentTraffic")
        )
          writer
            .uint32(/* id 12, wireType 1 =*/ 97)
            .double(message.percentTraffic);
        if (
          message.qualityPower != null &&
          Object.hasOwnProperty.call(message, "qualityPower")
        )
          writer
            .uint32(/* id 13, wireType 0 =*/ 104)
            .int32(message.qualityPower);
        if (
          message.isDown != null &&
          Object.hasOwnProperty.call(message, "isDown")
        )
          writer.uint32(/* id 14, wireType 0 =*/ 112).bool(message.isDown);
        if (
          message.corTrafficTx != null &&
          Object.hasOwnProperty.call(message, "corTrafficTx")
        )
          $root.network.monitor.StatusColor.encode(
            message.corTrafficTx,
            writer.uint32(/* id 15, wireType 2 =*/ 122).fork(),
          ).ldelim();
        if (
          message.corTrafficRx != null &&
          Object.hasOwnProperty.call(message, "corTrafficRx")
        )
          $root.network.monitor.StatusColor.encode(
            message.corTrafficRx,
            writer.uint32(/* id 16, wireType 2 =*/ 130).fork(),
          ).ldelim();
        if (
          message.corPowerTx != null &&
          Object.hasOwnProperty.call(message, "corPowerTx")
        )
          $root.network.monitor.StatusColor.encode(
            message.corPowerTx,
            writer.uint32(/* id 17, wireType 2 =*/ 138).fork(),
          ).ldelim();
        if (
          message.corPowerRx != null &&
          Object.hasOwnProperty.call(message, "corPowerRx")
        )
          $root.network.monitor.StatusColor.encode(
            message.corPowerRx,
            writer.uint32(/* id 18, wireType 2 =*/ 146).fork(),
          ).ldelim();
        if (
          message.percentTrafficTx != null &&
          Object.hasOwnProperty.call(message, "percentTrafficTx")
        )
          writer
            .uint32(/* id 19, wireType 1 =*/ 153)
            .double(message.percentTrafficTx);
        if (
          message.percentTrafficRx != null &&
          Object.hasOwnProperty.call(message, "percentTrafficRx")
        )
          writer
            .uint32(/* id 20, wireType 1 =*/ 161)
            .double(message.percentTrafficRx);
        if (
          message.qualityPowerTx != null &&
          Object.hasOwnProperty.call(message, "qualityPowerTx")
        )
          writer
            .uint32(/* id 21, wireType 0 =*/ 168)
            .int32(message.qualityPowerTx);
        if (
          message.qualityPowerRx != null &&
          Object.hasOwnProperty.call(message, "qualityPowerRx")
        )
          writer
            .uint32(/* id 22, wireType 0 =*/ 176)
            .int32(message.qualityPowerRx);
        return writer;
      };

      /**
       * Encodes the specified Connection message, length delimited. Does not implicitly {@link network.monitor.Connection.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.Connection
       * @static
       * @param {network.monitor.IConnection} message Connection message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Connection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Connection message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.Connection
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.Connection} Connection
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Connection.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.Connection();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.id = reader.string();
              break;
            }
            case 2: {
              message["interface"] = reader.string();
              break;
            }
            case 3: {
              if (!(message.itensData && message.itensData.length))
                message.itensData = [];
              message.itensData.push(
                $root.network.monitor.ItemData.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 4: {
              message.rx_traffic = reader.int64();
              break;
            }
            case 5: {
              message.tx_power = reader.double();
              break;
            }
            case 6: {
              message.rx_power = reader.double();
              break;
            }
            case 7: {
              message.tx_traffic = reader.int64();
              break;
            }
            case 8: {
              message.capacidade_zabbix = reader.int64();
              break;
            }
            case 9: {
              message.status = reader.int32();
              break;
            }
            case 10: {
              message.corTraffic = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 11: {
              message.corPower = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 12: {
              message.percentTraffic = reader.double();
              break;
            }
            case 13: {
              message.qualityPower = reader.int32();
              break;
            }
            case 14: {
              message.isDown = reader.bool();
              break;
            }
            case 15: {
              message.corTrafficTx = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 16: {
              message.corTrafficRx = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 17: {
              message.corPowerTx = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 18: {
              message.corPowerRx = $root.network.monitor.StatusColor.decode(
                reader,
                reader.uint32(),
                undefined,
                long + 1,
              );
              break;
            }
            case 19: {
              message.percentTrafficTx = reader.double();
              break;
            }
            case 20: {
              message.percentTrafficRx = reader.double();
              break;
            }
            case 21: {
              message.qualityPowerTx = reader.int32();
              break;
            }
            case 22: {
              message.qualityPowerRx = reader.int32();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Connection message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.Connection
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.Connection} Connection
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Connection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Connection message.
       * @function verify
       * @memberof network.monitor.Connection
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Connection.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.id != null && message.hasOwnProperty("id"))
          if (!$util.isString(message.id)) return "id: string expected";
        if (message["interface"] != null && message.hasOwnProperty("interface"))
          if (!$util.isString(message["interface"]))
            return "interface: string expected";
        if (message.itensData != null && message.hasOwnProperty("itensData")) {
          if (!Array.isArray(message.itensData))
            return "itensData: array expected";
          for (let i = 0; i < message.itensData.length; ++i) {
            let error = $root.network.monitor.ItemData.verify(
              message.itensData[i],
              long + 1,
            );
            if (error) return "itensData." + error;
          }
        }
        if (message.rx_traffic != null && message.hasOwnProperty("rx_traffic"))
          if (
            !$util.isInteger(message.rx_traffic) &&
            !(
              message.rx_traffic &&
              $util.isInteger(message.rx_traffic.low) &&
              $util.isInteger(message.rx_traffic.high)
            )
          )
            return "rx_traffic: integer|Long expected";
        if (message.tx_power != null && message.hasOwnProperty("tx_power"))
          if (typeof message.tx_power !== "number")
            return "tx_power: number expected";
        if (message.rx_power != null && message.hasOwnProperty("rx_power"))
          if (typeof message.rx_power !== "number")
            return "rx_power: number expected";
        if (message.tx_traffic != null && message.hasOwnProperty("tx_traffic"))
          if (
            !$util.isInteger(message.tx_traffic) &&
            !(
              message.tx_traffic &&
              $util.isInteger(message.tx_traffic.low) &&
              $util.isInteger(message.tx_traffic.high)
            )
          )
            return "tx_traffic: integer|Long expected";
        if (
          message.capacidade_zabbix != null &&
          message.hasOwnProperty("capacidade_zabbix")
        )
          if (
            !$util.isInteger(message.capacidade_zabbix) &&
            !(
              message.capacidade_zabbix &&
              $util.isInteger(message.capacidade_zabbix.low) &&
              $util.isInteger(message.capacidade_zabbix.high)
            )
          )
            return "capacidade_zabbix: integer|Long expected";
        if (message.status != null && message.hasOwnProperty("status"))
          if (!$util.isInteger(message.status))
            return "status: integer expected";
        if (
          message.corTraffic != null &&
          message.hasOwnProperty("corTraffic")
        ) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corTraffic,
            long + 1,
          );
          if (error) return "corTraffic." + error;
        }
        if (message.corPower != null && message.hasOwnProperty("corPower")) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corPower,
            long + 1,
          );
          if (error) return "corPower." + error;
        }
        if (
          message.percentTraffic != null &&
          message.hasOwnProperty("percentTraffic")
        )
          if (typeof message.percentTraffic !== "number")
            return "percentTraffic: number expected";
        if (
          message.qualityPower != null &&
          message.hasOwnProperty("qualityPower")
        )
          if (!$util.isInteger(message.qualityPower))
            return "qualityPower: integer expected";
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          if (typeof message.isDown !== "boolean")
            return "isDown: boolean expected";
        if (
          message.corTrafficTx != null &&
          message.hasOwnProperty("corTrafficTx")
        ) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corTrafficTx,
            long + 1,
          );
          if (error) return "corTrafficTx." + error;
        }
        if (
          message.corTrafficRx != null &&
          message.hasOwnProperty("corTrafficRx")
        ) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corTrafficRx,
            long + 1,
          );
          if (error) return "corTrafficRx." + error;
        }
        if (
          message.corPowerTx != null &&
          message.hasOwnProperty("corPowerTx")
        ) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corPowerTx,
            long + 1,
          );
          if (error) return "corPowerTx." + error;
        }
        if (
          message.corPowerRx != null &&
          message.hasOwnProperty("corPowerRx")
        ) {
          let error = $root.network.monitor.StatusColor.verify(
            message.corPowerRx,
            long + 1,
          );
          if (error) return "corPowerRx." + error;
        }
        if (
          message.percentTrafficTx != null &&
          message.hasOwnProperty("percentTrafficTx")
        )
          if (typeof message.percentTrafficTx !== "number")
            return "percentTrafficTx: number expected";
        if (
          message.percentTrafficRx != null &&
          message.hasOwnProperty("percentTrafficRx")
        )
          if (typeof message.percentTrafficRx !== "number")
            return "percentTrafficRx: number expected";
        if (
          message.qualityPowerTx != null &&
          message.hasOwnProperty("qualityPowerTx")
        )
          if (!$util.isInteger(message.qualityPowerTx))
            return "qualityPowerTx: integer expected";
        if (
          message.qualityPowerRx != null &&
          message.hasOwnProperty("qualityPowerRx")
        )
          if (!$util.isInteger(message.qualityPowerRx))
            return "qualityPowerRx: integer expected";
        return null;
      };

      /**
       * Creates a Connection message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.Connection
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.Connection} Connection
       */
      Connection.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.Connection) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.Connection();
        if (object.id != null) message.id = String(object.id);
        if (object["interface"] != null)
          message["interface"] = String(object["interface"]);
        if (object.itensData) {
          if (!Array.isArray(object.itensData))
            throw TypeError(
              ".network.monitor.Connection.itensData: array expected",
            );
          message.itensData = [];
          for (let i = 0; i < object.itensData.length; ++i) {
            if (typeof object.itensData[i] !== "object")
              throw TypeError(
                ".network.monitor.Connection.itensData: object expected",
              );
            message.itensData[i] = $root.network.monitor.ItemData.fromObject(
              object.itensData[i],
              long + 1,
            );
          }
        }
        if (object.rx_traffic != null)
          if ($util.Long)
            (message.rx_traffic = $util.Long.fromValue(
              object.rx_traffic,
            )).unsigned = false;
          else if (typeof object.rx_traffic === "string")
            message.rx_traffic = parseInt(object.rx_traffic, 10);
          else if (typeof object.rx_traffic === "number")
            message.rx_traffic = object.rx_traffic;
          else if (typeof object.rx_traffic === "object")
            message.rx_traffic = new $util.LongBits(
              object.rx_traffic.low >>> 0,
              object.rx_traffic.high >>> 0,
            ).toNumber();
        if (object.tx_power != null) message.tx_power = Number(object.tx_power);
        if (object.rx_power != null) message.rx_power = Number(object.rx_power);
        if (object.tx_traffic != null)
          if ($util.Long)
            (message.tx_traffic = $util.Long.fromValue(
              object.tx_traffic,
            )).unsigned = false;
          else if (typeof object.tx_traffic === "string")
            message.tx_traffic = parseInt(object.tx_traffic, 10);
          else if (typeof object.tx_traffic === "number")
            message.tx_traffic = object.tx_traffic;
          else if (typeof object.tx_traffic === "object")
            message.tx_traffic = new $util.LongBits(
              object.tx_traffic.low >>> 0,
              object.tx_traffic.high >>> 0,
            ).toNumber();
        if (object.capacidade_zabbix != null)
          if ($util.Long)
            (message.capacidade_zabbix = $util.Long.fromValue(
              object.capacidade_zabbix,
            )).unsigned = false;
          else if (typeof object.capacidade_zabbix === "string")
            message.capacidade_zabbix = parseInt(object.capacidade_zabbix, 10);
          else if (typeof object.capacidade_zabbix === "number")
            message.capacidade_zabbix = object.capacidade_zabbix;
          else if (typeof object.capacidade_zabbix === "object")
            message.capacidade_zabbix = new $util.LongBits(
              object.capacidade_zabbix.low >>> 0,
              object.capacidade_zabbix.high >>> 0,
            ).toNumber();
        if (object.status != null) message.status = object.status | 0;
        if (object.corTraffic != null) {
          if (typeof object.corTraffic !== "object")
            throw TypeError(
              ".network.monitor.Connection.corTraffic: object expected",
            );
          message.corTraffic = $root.network.monitor.StatusColor.fromObject(
            object.corTraffic,
            long + 1,
          );
        }
        if (object.corPower != null) {
          if (typeof object.corPower !== "object")
            throw TypeError(
              ".network.monitor.Connection.corPower: object expected",
            );
          message.corPower = $root.network.monitor.StatusColor.fromObject(
            object.corPower,
            long + 1,
          );
        }
        if (object.percentTraffic != null)
          message.percentTraffic = Number(object.percentTraffic);
        if (object.qualityPower != null)
          message.qualityPower = object.qualityPower | 0;
        if (object.isDown != null) message.isDown = Boolean(object.isDown);
        if (object.corTrafficTx != null) {
          if (typeof object.corTrafficTx !== "object")
            throw TypeError(
              ".network.monitor.Connection.corTrafficTx: object expected",
            );
          message.corTrafficTx = $root.network.monitor.StatusColor.fromObject(
            object.corTrafficTx,
            long + 1,
          );
        }
        if (object.corTrafficRx != null) {
          if (typeof object.corTrafficRx !== "object")
            throw TypeError(
              ".network.monitor.Connection.corTrafficRx: object expected",
            );
          message.corTrafficRx = $root.network.monitor.StatusColor.fromObject(
            object.corTrafficRx,
            long + 1,
          );
        }
        if (object.corPowerTx != null) {
          if (typeof object.corPowerTx !== "object")
            throw TypeError(
              ".network.monitor.Connection.corPowerTx: object expected",
            );
          message.corPowerTx = $root.network.monitor.StatusColor.fromObject(
            object.corPowerTx,
            long + 1,
          );
        }
        if (object.corPowerRx != null) {
          if (typeof object.corPowerRx !== "object")
            throw TypeError(
              ".network.monitor.Connection.corPowerRx: object expected",
            );
          message.corPowerRx = $root.network.monitor.StatusColor.fromObject(
            object.corPowerRx,
            long + 1,
          );
        }
        if (object.percentTrafficTx != null)
          message.percentTrafficTx = Number(object.percentTrafficTx);
        if (object.percentTrafficRx != null)
          message.percentTrafficRx = Number(object.percentTrafficRx);
        if (object.qualityPowerTx != null)
          message.qualityPowerTx = object.qualityPowerTx | 0;
        if (object.qualityPowerRx != null)
          message.qualityPowerRx = object.qualityPowerRx | 0;
        return message;
      };

      /**
       * Creates a plain object from a Connection message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.Connection
       * @static
       * @param {network.monitor.Connection} message Connection
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Connection.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.arrays || options.defaults) object.itensData = [];
        if (options.defaults) {
          object.id = "";
          object["interface"] = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.rx_traffic =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                  ? long.toNumber()
                  : long;
          } else object.rx_traffic = options.longs === String ? "0" : 0;
          object.tx_power = 0;
          object.rx_power = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.tx_traffic =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                  ? long.toNumber()
                  : long;
          } else object.tx_traffic = options.longs === String ? "0" : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.capacidade_zabbix =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                  ? long.toNumber()
                  : long;
          } else object.capacidade_zabbix = options.longs === String ? "0" : 0;
          object.status = 0;
          object.corTraffic = null;
          object.corPower = null;
          object.percentTraffic = 0;
          object.qualityPower = 0;
          object.isDown = false;
          object.corTrafficTx = null;
          object.corTrafficRx = null;
          object.corPowerTx = null;
          object.corPowerRx = null;
          object.percentTrafficTx = 0;
          object.percentTrafficRx = 0;
          object.qualityPowerTx = 0;
          object.qualityPowerRx = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message["interface"] != null && message.hasOwnProperty("interface"))
          object["interface"] = message["interface"];
        if (message.itensData && message.itensData.length) {
          object.itensData = [];
          for (let j = 0; j < message.itensData.length; ++j)
            object.itensData[j] = $root.network.monitor.ItemData.toObject(
              message.itensData[j],
              options,
            );
        }
        if (message.rx_traffic != null && message.hasOwnProperty("rx_traffic"))
          if (typeof message.rx_traffic === "number")
            object.rx_traffic =
              options.longs === String
                ? String(message.rx_traffic)
                : message.rx_traffic;
          else
            object.rx_traffic =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.rx_traffic)
                : options.longs === Number
                  ? new $util.LongBits(
                      message.rx_traffic.low >>> 0,
                      message.rx_traffic.high >>> 0,
                    ).toNumber()
                  : message.rx_traffic;
        if (message.tx_power != null && message.hasOwnProperty("tx_power"))
          object.tx_power =
            options.json && !isFinite(message.tx_power)
              ? String(message.tx_power)
              : message.tx_power;
        if (message.rx_power != null && message.hasOwnProperty("rx_power"))
          object.rx_power =
            options.json && !isFinite(message.rx_power)
              ? String(message.rx_power)
              : message.rx_power;
        if (message.tx_traffic != null && message.hasOwnProperty("tx_traffic"))
          if (typeof message.tx_traffic === "number")
            object.tx_traffic =
              options.longs === String
                ? String(message.tx_traffic)
                : message.tx_traffic;
          else
            object.tx_traffic =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.tx_traffic)
                : options.longs === Number
                  ? new $util.LongBits(
                      message.tx_traffic.low >>> 0,
                      message.tx_traffic.high >>> 0,
                    ).toNumber()
                  : message.tx_traffic;
        if (
          message.capacidade_zabbix != null &&
          message.hasOwnProperty("capacidade_zabbix")
        )
          if (typeof message.capacidade_zabbix === "number")
            object.capacidade_zabbix =
              options.longs === String
                ? String(message.capacidade_zabbix)
                : message.capacidade_zabbix;
          else
            object.capacidade_zabbix =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.capacidade_zabbix)
                : options.longs === Number
                  ? new $util.LongBits(
                      message.capacidade_zabbix.low >>> 0,
                      message.capacidade_zabbix.high >>> 0,
                    ).toNumber()
                  : message.capacidade_zabbix;
        if (message.status != null && message.hasOwnProperty("status"))
          object.status = message.status;
        if (message.corTraffic != null && message.hasOwnProperty("corTraffic"))
          object.corTraffic = $root.network.monitor.StatusColor.toObject(
            message.corTraffic,
            options,
          );
        if (message.corPower != null && message.hasOwnProperty("corPower"))
          object.corPower = $root.network.monitor.StatusColor.toObject(
            message.corPower,
            options,
          );
        if (
          message.percentTraffic != null &&
          message.hasOwnProperty("percentTraffic")
        )
          object.percentTraffic =
            options.json && !isFinite(message.percentTraffic)
              ? String(message.percentTraffic)
              : message.percentTraffic;
        if (
          message.qualityPower != null &&
          message.hasOwnProperty("qualityPower")
        )
          object.qualityPower = message.qualityPower;
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          object.isDown = message.isDown;
        if (
          message.corTrafficTx != null &&
          message.hasOwnProperty("corTrafficTx")
        )
          object.corTrafficTx = $root.network.monitor.StatusColor.toObject(
            message.corTrafficTx,
            options,
          );
        if (
          message.corTrafficRx != null &&
          message.hasOwnProperty("corTrafficRx")
        )
          object.corTrafficRx = $root.network.monitor.StatusColor.toObject(
            message.corTrafficRx,
            options,
          );
        if (message.corPowerTx != null && message.hasOwnProperty("corPowerTx"))
          object.corPowerTx = $root.network.monitor.StatusColor.toObject(
            message.corPowerTx,
            options,
          );
        if (message.corPowerRx != null && message.hasOwnProperty("corPowerRx"))
          object.corPowerRx = $root.network.monitor.StatusColor.toObject(
            message.corPowerRx,
            options,
          );
        if (
          message.percentTrafficTx != null &&
          message.hasOwnProperty("percentTrafficTx")
        )
          object.percentTrafficTx =
            options.json && !isFinite(message.percentTrafficTx)
              ? String(message.percentTrafficTx)
              : message.percentTrafficTx;
        if (
          message.percentTrafficRx != null &&
          message.hasOwnProperty("percentTrafficRx")
        )
          object.percentTrafficRx =
            options.json && !isFinite(message.percentTrafficRx)
              ? String(message.percentTrafficRx)
              : message.percentTrafficRx;
        if (
          message.qualityPowerTx != null &&
          message.hasOwnProperty("qualityPowerTx")
        )
          object.qualityPowerTx = message.qualityPowerTx;
        if (
          message.qualityPowerRx != null &&
          message.hasOwnProperty("qualityPowerRx")
        )
          object.qualityPowerRx = message.qualityPowerRx;
        return object;
      };

      /**
       * Converts this Connection to JSON.
       * @function toJSON
       * @memberof network.monitor.Connection
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Connection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for Connection
       * @function getTypeUrl
       * @memberof network.monitor.Connection
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      Connection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.Connection";
      };

      return Connection;
    })();

    monitor.Host = (function () {
      /**
       * Properties of a Host.
       * @memberof network.monitor
       * @interface IHost
       * @property {string|null} [name] Host name
       * @property {string|null} [hostid] Host hostid
       * @property {string|null} [snmp] Host snmp
       * @property {string|null} [ping] Host ping
       * @property {string|null} [perdaPing] Host perdaPing
       * @property {string|null} [latencia] Host latencia
       * @property {Array.<network.monitor.IItemData>|null} [itensData] Host itensData
       * @property {boolean|null} [isDown] Host isDown
       * @property {Array.<string>|null} [groups] Host groups
       * @property {string|null} [uptime] Host uptime
       * @property {boolean|null} [hasSysUpTime] Host hasSysUpTime
       */

      /**
       * Constructs a new Host.
       * @memberof network.monitor
       * @classdesc Represents a Host.
       * @implements IHost
       * @constructor
       * @param {network.monitor.IHost=} [properties] Properties to set
       */
      function Host(properties) {
        this.itensData = [];
        this.groups = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * Host name.
       * @member {string} name
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.name = "";

      /**
       * Host hostid.
       * @member {string} hostid
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.hostid = "";

      /**
       * Host snmp.
       * @member {string} snmp
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.snmp = "";

      /**
       * Host ping.
       * @member {string} ping
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.ping = "";

      /**
       * Host perdaPing.
       * @member {string} perdaPing
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.perdaPing = "";

      /**
       * Host latencia.
       * @member {string} latencia
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.latencia = "";

      /**
       * Host itensData.
       * @member {Array.<network.monitor.IItemData>} itensData
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.itensData = $util.emptyArray;

      /**
       * Host isDown.
       * @member {boolean} isDown
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.isDown = false;

      /**
       * Host groups.
       * @member {Array.<string>} groups
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.groups = $util.emptyArray;

      /**
       * Host uptime.
       * @member {string} uptime
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.uptime = "";

      /**
       * Host hasSysUpTime.
       * @member {boolean} hasSysUpTime
       * @memberof network.monitor.Host
       * @instance
       */
      Host.prototype.hasSysUpTime = false;

      /**
       * Creates a new Host instance using the specified properties.
       * @function create
       * @memberof network.monitor.Host
       * @static
       * @param {network.monitor.IHost=} [properties] Properties to set
       * @returns {network.monitor.Host} Host instance
       */
      Host.create = function create(properties) {
        return new Host(properties);
      };

      /**
       * Encodes the specified Host message. Does not implicitly {@link network.monitor.Host.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.Host
       * @static
       * @param {network.monitor.IHost} message Host message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Host.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
        if (
          message.hostid != null &&
          Object.hasOwnProperty.call(message, "hostid")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.hostid);
        if (message.snmp != null && Object.hasOwnProperty.call(message, "snmp"))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.snmp);
        if (message.ping != null && Object.hasOwnProperty.call(message, "ping"))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.ping);
        if (
          message.perdaPing != null &&
          Object.hasOwnProperty.call(message, "perdaPing")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.perdaPing);
        if (
          message.latencia != null &&
          Object.hasOwnProperty.call(message, "latencia")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.latencia);
        if (message.itensData != null && message.itensData.length)
          for (let i = 0; i < message.itensData.length; ++i)
            $root.network.monitor.ItemData.encode(
              message.itensData[i],
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork(),
            ).ldelim();
        if (
          message.isDown != null &&
          Object.hasOwnProperty.call(message, "isDown")
        )
          writer.uint32(/* id 8, wireType 0 =*/ 64).bool(message.isDown);
        if (message.groups != null && message.groups.length)
          for (let i = 0; i < message.groups.length; ++i)
            writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.groups[i]);
        if (
          message.uptime != null &&
          Object.hasOwnProperty.call(message, "uptime")
        )
          writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.uptime);
        if (
          message.hasSysUpTime != null &&
          Object.hasOwnProperty.call(message, "hasSysUpTime")
        )
          writer.uint32(/* id 11, wireType 0 =*/ 88).bool(message.hasSysUpTime);
        return writer;
      };

      /**
       * Encodes the specified Host message, length delimited. Does not implicitly {@link network.monitor.Host.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.Host
       * @static
       * @param {network.monitor.IHost} message Host message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Host.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Host message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.Host
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.Host} Host
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Host.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.Host();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.name = reader.string();
              break;
            }
            case 2: {
              message.hostid = reader.string();
              break;
            }
            case 3: {
              message.snmp = reader.string();
              break;
            }
            case 4: {
              message.ping = reader.string();
              break;
            }
            case 5: {
              message.perdaPing = reader.string();
              break;
            }
            case 6: {
              message.latencia = reader.string();
              break;
            }
            case 7: {
              if (!(message.itensData && message.itensData.length))
                message.itensData = [];
              message.itensData.push(
                $root.network.monitor.ItemData.decode(
                  reader,
                  reader.uint32(),
                  undefined,
                  long + 1,
                ),
              );
              break;
            }
            case 8: {
              message.isDown = reader.bool();
              break;
            }
            case 9: {
              if (!(message.groups && message.groups.length))
                message.groups = [];
              message.groups.push(reader.string());
              break;
            }
            case 10: {
              message.uptime = reader.string();
              break;
            }
            case 11: {
              message.hasSysUpTime = reader.bool();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Host message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.Host
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.Host} Host
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Host.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Host message.
       * @function verify
       * @memberof network.monitor.Host
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Host.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.name != null && message.hasOwnProperty("name"))
          if (!$util.isString(message.name)) return "name: string expected";
        if (message.hostid != null && message.hasOwnProperty("hostid"))
          if (!$util.isString(message.hostid)) return "hostid: string expected";
        if (message.snmp != null && message.hasOwnProperty("snmp"))
          if (!$util.isString(message.snmp)) return "snmp: string expected";
        if (message.ping != null && message.hasOwnProperty("ping"))
          if (!$util.isString(message.ping)) return "ping: string expected";
        if (message.perdaPing != null && message.hasOwnProperty("perdaPing"))
          if (!$util.isString(message.perdaPing))
            return "perdaPing: string expected";
        if (message.latencia != null && message.hasOwnProperty("latencia"))
          if (!$util.isString(message.latencia))
            return "latencia: string expected";
        if (message.itensData != null && message.hasOwnProperty("itensData")) {
          if (!Array.isArray(message.itensData))
            return "itensData: array expected";
          for (let i = 0; i < message.itensData.length; ++i) {
            let error = $root.network.monitor.ItemData.verify(
              message.itensData[i],
              long + 1,
            );
            if (error) return "itensData." + error;
          }
        }
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          if (typeof message.isDown !== "boolean")
            return "isDown: boolean expected";
        if (message.groups != null && message.hasOwnProperty("groups")) {
          if (!Array.isArray(message.groups)) return "groups: array expected";
          for (let i = 0; i < message.groups.length; ++i)
            if (!$util.isString(message.groups[i]))
              return "groups: string[] expected";
        }
        if (message.uptime != null && message.hasOwnProperty("uptime"))
          if (!$util.isString(message.uptime)) return "uptime: string expected";
        if (
          message.hasSysUpTime != null &&
          message.hasOwnProperty("hasSysUpTime")
        )
          if (typeof message.hasSysUpTime !== "boolean")
            return "hasSysUpTime: boolean expected";
        return null;
      };

      /**
       * Creates a Host message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.Host
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.Host} Host
       */
      Host.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.Host) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.Host();
        if (object.name != null) message.name = String(object.name);
        if (object.hostid != null) message.hostid = String(object.hostid);
        if (object.snmp != null) message.snmp = String(object.snmp);
        if (object.ping != null) message.ping = String(object.ping);
        if (object.perdaPing != null)
          message.perdaPing = String(object.perdaPing);
        if (object.latencia != null) message.latencia = String(object.latencia);
        if (object.itensData) {
          if (!Array.isArray(object.itensData))
            throw TypeError(".network.monitor.Host.itensData: array expected");
          message.itensData = [];
          for (let i = 0; i < object.itensData.length; ++i) {
            if (typeof object.itensData[i] !== "object")
              throw TypeError(
                ".network.monitor.Host.itensData: object expected",
              );
            message.itensData[i] = $root.network.monitor.ItemData.fromObject(
              object.itensData[i],
              long + 1,
            );
          }
        }
        if (object.isDown != null) message.isDown = Boolean(object.isDown);
        if (object.groups) {
          if (!Array.isArray(object.groups))
            throw TypeError(".network.monitor.Host.groups: array expected");
          message.groups = [];
          for (let i = 0; i < object.groups.length; ++i)
            message.groups[i] = String(object.groups[i]);
        }
        if (object.uptime != null) message.uptime = String(object.uptime);
        if (object.hasSysUpTime != null)
          message.hasSysUpTime = Boolean(object.hasSysUpTime);
        return message;
      };

      /**
       * Creates a plain object from a Host message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.Host
       * @static
       * @param {network.monitor.Host} message Host
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Host.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.arrays || options.defaults) {
          object.itensData = [];
          object.groups = [];
        }
        if (options.defaults) {
          object.name = "";
          object.hostid = "";
          object.snmp = "";
          object.ping = "";
          object.perdaPing = "";
          object.latencia = "";
          object.isDown = false;
          object.uptime = "";
          object.hasSysUpTime = false;
        }
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        if (message.hostid != null && message.hasOwnProperty("hostid"))
          object.hostid = message.hostid;
        if (message.snmp != null && message.hasOwnProperty("snmp"))
          object.snmp = message.snmp;
        if (message.ping != null && message.hasOwnProperty("ping"))
          object.ping = message.ping;
        if (message.perdaPing != null && message.hasOwnProperty("perdaPing"))
          object.perdaPing = message.perdaPing;
        if (message.latencia != null && message.hasOwnProperty("latencia"))
          object.latencia = message.latencia;
        if (message.itensData && message.itensData.length) {
          object.itensData = [];
          for (let j = 0; j < message.itensData.length; ++j)
            object.itensData[j] = $root.network.monitor.ItemData.toObject(
              message.itensData[j],
              options,
            );
        }
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          object.isDown = message.isDown;
        if (message.groups && message.groups.length) {
          object.groups = [];
          for (let j = 0; j < message.groups.length; ++j)
            object.groups[j] = message.groups[j];
        }
        if (message.uptime != null && message.hasOwnProperty("uptime"))
          object.uptime = message.uptime;
        if (
          message.hasSysUpTime != null &&
          message.hasOwnProperty("hasSysUpTime")
        )
          object.hasSysUpTime = message.hasSysUpTime;
        return object;
      };

      /**
       * Converts this Host to JSON.
       * @function toJSON
       * @memberof network.monitor.Host
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Host.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for Host
       * @function getTypeUrl
       * @memberof network.monitor.Host
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      Host.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.Host";
      };

      return Host;
    })();

    monitor.ItemData = (function () {
      /**
       * Properties of an ItemData.
       * @memberof network.monitor
       * @interface IItemData
       * @property {string|null} [key_] ItemData key_
       * @property {string|null} [lastvalue] ItemData lastvalue
       * @property {string|null} [units] ItemData units
       * @property {string|null} [name] ItemData name
       */

      /**
       * Constructs a new ItemData.
       * @memberof network.monitor
       * @classdesc Represents an ItemData.
       * @implements IItemData
       * @constructor
       * @param {network.monitor.IItemData=} [properties] Properties to set
       */
      function ItemData(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * ItemData key_.
       * @member {string} key_
       * @memberof network.monitor.ItemData
       * @instance
       */
      ItemData.prototype.key_ = "";

      /**
       * ItemData lastvalue.
       * @member {string} lastvalue
       * @memberof network.monitor.ItemData
       * @instance
       */
      ItemData.prototype.lastvalue = "";

      /**
       * ItemData units.
       * @member {string} units
       * @memberof network.monitor.ItemData
       * @instance
       */
      ItemData.prototype.units = "";

      /**
       * ItemData name.
       * @member {string} name
       * @memberof network.monitor.ItemData
       * @instance
       */
      ItemData.prototype.name = "";

      /**
       * Creates a new ItemData instance using the specified properties.
       * @function create
       * @memberof network.monitor.ItemData
       * @static
       * @param {network.monitor.IItemData=} [properties] Properties to set
       * @returns {network.monitor.ItemData} ItemData instance
       */
      ItemData.create = function create(properties) {
        return new ItemData(properties);
      };

      /**
       * Encodes the specified ItemData message. Does not implicitly {@link network.monitor.ItemData.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.ItemData
       * @static
       * @param {network.monitor.IItemData} message ItemData message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ItemData.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.key_ != null && Object.hasOwnProperty.call(message, "key_"))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.key_);
        if (
          message.lastvalue != null &&
          Object.hasOwnProperty.call(message, "lastvalue")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.lastvalue);
        if (
          message.units != null &&
          Object.hasOwnProperty.call(message, "units")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.units);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.name);
        return writer;
      };

      /**
       * Encodes the specified ItemData message, length delimited. Does not implicitly {@link network.monitor.ItemData.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.ItemData
       * @static
       * @param {network.monitor.IItemData} message ItemData message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ItemData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an ItemData message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.ItemData
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.ItemData} ItemData
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ItemData.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.ItemData();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.key_ = reader.string();
              break;
            }
            case 2: {
              message.lastvalue = reader.string();
              break;
            }
            case 3: {
              message.units = reader.string();
              break;
            }
            case 4: {
              message.name = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an ItemData message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.ItemData
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.ItemData} ItemData
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ItemData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an ItemData message.
       * @function verify
       * @memberof network.monitor.ItemData
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      ItemData.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.key_ != null && message.hasOwnProperty("key_"))
          if (!$util.isString(message.key_)) return "key_: string expected";
        if (message.lastvalue != null && message.hasOwnProperty("lastvalue"))
          if (!$util.isString(message.lastvalue))
            return "lastvalue: string expected";
        if (message.units != null && message.hasOwnProperty("units"))
          if (!$util.isString(message.units)) return "units: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
          if (!$util.isString(message.name)) return "name: string expected";
        return null;
      };

      /**
       * Creates an ItemData message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.ItemData
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.ItemData} ItemData
       */
      ItemData.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.ItemData) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.ItemData();
        if (object.key_ != null) message.key_ = String(object.key_);
        if (object.lastvalue != null)
          message.lastvalue = String(object.lastvalue);
        if (object.units != null) message.units = String(object.units);
        if (object.name != null) message.name = String(object.name);
        return message;
      };

      /**
       * Creates a plain object from an ItemData message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.ItemData
       * @static
       * @param {network.monitor.ItemData} message ItemData
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      ItemData.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.key_ = "";
          object.lastvalue = "";
          object.units = "";
          object.name = "";
        }
        if (message.key_ != null && message.hasOwnProperty("key_"))
          object.key_ = message.key_;
        if (message.lastvalue != null && message.hasOwnProperty("lastvalue"))
          object.lastvalue = message.lastvalue;
        if (message.units != null && message.hasOwnProperty("units"))
          object.units = message.units;
        if (message.name != null && message.hasOwnProperty("name"))
          object.name = message.name;
        return object;
      };

      /**
       * Converts this ItemData to JSON.
       * @function toJSON
       * @memberof network.monitor.ItemData
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      ItemData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for ItemData
       * @function getTypeUrl
       * @memberof network.monitor.ItemData
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      ItemData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.ItemData";
      };

      return ItemData;
    })();

    monitor.StatusColor = (function () {
      /**
       * Properties of a StatusColor.
       * @memberof network.monitor
       * @interface IStatusColor
       * @property {string|null} [id] StatusColor id
       * @property {string|null} [cor] StatusColor cor
       * @property {string|null} [label] StatusColor label
       */

      /**
       * Constructs a new StatusColor.
       * @memberof network.monitor
       * @classdesc Represents a StatusColor.
       * @implements IStatusColor
       * @constructor
       * @param {network.monitor.IStatusColor=} [properties] Properties to set
       */
      function StatusColor(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * StatusColor id.
       * @member {string} id
       * @memberof network.monitor.StatusColor
       * @instance
       */
      StatusColor.prototype.id = "";

      /**
       * StatusColor cor.
       * @member {string} cor
       * @memberof network.monitor.StatusColor
       * @instance
       */
      StatusColor.prototype.cor = "";

      /**
       * StatusColor label.
       * @member {string} label
       * @memberof network.monitor.StatusColor
       * @instance
       */
      StatusColor.prototype.label = "";

      /**
       * Creates a new StatusColor instance using the specified properties.
       * @function create
       * @memberof network.monitor.StatusColor
       * @static
       * @param {network.monitor.IStatusColor=} [properties] Properties to set
       * @returns {network.monitor.StatusColor} StatusColor instance
       */
      StatusColor.create = function create(properties) {
        return new StatusColor(properties);
      };

      /**
       * Encodes the specified StatusColor message. Does not implicitly {@link network.monitor.StatusColor.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.StatusColor
       * @static
       * @param {network.monitor.IStatusColor} message StatusColor message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      StatusColor.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.id);
        if (message.cor != null && Object.hasOwnProperty.call(message, "cor"))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.cor);
        if (
          message.label != null &&
          Object.hasOwnProperty.call(message, "label")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.label);
        return writer;
      };

      /**
       * Encodes the specified StatusColor message, length delimited. Does not implicitly {@link network.monitor.StatusColor.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.StatusColor
       * @static
       * @param {network.monitor.IStatusColor} message StatusColor message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      StatusColor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a StatusColor message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.StatusColor
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.StatusColor} StatusColor
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      StatusColor.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.StatusColor();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.id = reader.string();
              break;
            }
            case 2: {
              message.cor = reader.string();
              break;
            }
            case 3: {
              message.label = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a StatusColor message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.StatusColor
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.StatusColor} StatusColor
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      StatusColor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a StatusColor message.
       * @function verify
       * @memberof network.monitor.StatusColor
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      StatusColor.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.id != null && message.hasOwnProperty("id"))
          if (!$util.isString(message.id)) return "id: string expected";
        if (message.cor != null && message.hasOwnProperty("cor"))
          if (!$util.isString(message.cor)) return "cor: string expected";
        if (message.label != null && message.hasOwnProperty("label"))
          if (!$util.isString(message.label)) return "label: string expected";
        return null;
      };

      /**
       * Creates a StatusColor message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.StatusColor
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.StatusColor} StatusColor
       */
      StatusColor.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.StatusColor) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.StatusColor();
        if (object.id != null) message.id = String(object.id);
        if (object.cor != null) message.cor = String(object.cor);
        if (object.label != null) message.label = String(object.label);
        return message;
      };

      /**
       * Creates a plain object from a StatusColor message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.StatusColor
       * @static
       * @param {network.monitor.StatusColor} message StatusColor
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      StatusColor.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.id = "";
          object.cor = "";
          object.label = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
          object.id = message.id;
        if (message.cor != null && message.hasOwnProperty("cor"))
          object.cor = message.cor;
        if (message.label != null && message.hasOwnProperty("label"))
          object.label = message.label;
        return object;
      };

      /**
       * Converts this StatusColor to JSON.
       * @function toJSON
       * @memberof network.monitor.StatusColor
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      StatusColor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for StatusColor
       * @function getTypeUrl
       * @memberof network.monitor.StatusColor
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      StatusColor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.StatusColor";
      };

      return StatusColor;
    })();

    monitor.Config = (function () {
      /**
       * Properties of a Config.
       * @memberof network.monitor
       * @interface IConfig
       * @property {string|null} [background] Config background
       * @property {string|null} [border] Config border
       * @property {number|null} [severity] Config severity
       * @property {boolean|null} [isDown] Config isDown
       * @property {string|null} [viewType] Config viewType
       */

      /**
       * Constructs a new Config.
       * @memberof network.monitor
       * @classdesc Represents a Config.
       * @implements IConfig
       * @constructor
       * @param {network.monitor.IConfig=} [properties] Properties to set
       */
      function Config(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * Config background.
       * @member {string} background
       * @memberof network.monitor.Config
       * @instance
       */
      Config.prototype.background = "";

      /**
       * Config border.
       * @member {string} border
       * @memberof network.monitor.Config
       * @instance
       */
      Config.prototype.border = "";

      /**
       * Config severity.
       * @member {number} severity
       * @memberof network.monitor.Config
       * @instance
       */
      Config.prototype.severity = 0;

      /**
       * Config isDown.
       * @member {boolean} isDown
       * @memberof network.monitor.Config
       * @instance
       */
      Config.prototype.isDown = false;

      /**
       * Config viewType.
       * @member {string} viewType
       * @memberof network.monitor.Config
       * @instance
       */
      Config.prototype.viewType = "";

      /**
       * Creates a new Config instance using the specified properties.
       * @function create
       * @memberof network.monitor.Config
       * @static
       * @param {network.monitor.IConfig=} [properties] Properties to set
       * @returns {network.monitor.Config} Config instance
       */
      Config.create = function create(properties) {
        return new Config(properties);
      };

      /**
       * Encodes the specified Config message. Does not implicitly {@link network.monitor.Config.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.Config
       * @static
       * @param {network.monitor.IConfig} message Config message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Config.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.background != null &&
          Object.hasOwnProperty.call(message, "background")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.background);
        if (
          message.border != null &&
          Object.hasOwnProperty.call(message, "border")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.border);
        if (
          message.severity != null &&
          Object.hasOwnProperty.call(message, "severity")
        )
          writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.severity);
        if (
          message.isDown != null &&
          Object.hasOwnProperty.call(message, "isDown")
        )
          writer.uint32(/* id 4, wireType 0 =*/ 32).bool(message.isDown);
        if (
          message.viewType != null &&
          Object.hasOwnProperty.call(message, "viewType")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.viewType);
        return writer;
      };

      /**
       * Encodes the specified Config message, length delimited. Does not implicitly {@link network.monitor.Config.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.Config
       * @static
       * @param {network.monitor.IConfig} message Config message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Config.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Config message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.Config
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.Config} Config
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Config.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.Config();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.background = reader.string();
              break;
            }
            case 2: {
              message.border = reader.string();
              break;
            }
            case 3: {
              message.severity = reader.int32();
              break;
            }
            case 4: {
              message.isDown = reader.bool();
              break;
            }
            case 5: {
              message.viewType = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Config message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.Config
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.Config} Config
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Config.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Config message.
       * @function verify
       * @memberof network.monitor.Config
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Config.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.background != null && message.hasOwnProperty("background"))
          if (!$util.isString(message.background))
            return "background: string expected";
        if (message.border != null && message.hasOwnProperty("border"))
          if (!$util.isString(message.border)) return "border: string expected";
        if (message.severity != null && message.hasOwnProperty("severity"))
          if (!$util.isInteger(message.severity))
            return "severity: integer expected";
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          if (typeof message.isDown !== "boolean")
            return "isDown: boolean expected";
        if (message.viewType != null && message.hasOwnProperty("viewType"))
          if (!$util.isString(message.viewType))
            return "viewType: string expected";
        return null;
      };

      /**
       * Creates a Config message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.Config
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.Config} Config
       */
      Config.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.Config) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.Config();
        if (object.background != null)
          message.background = String(object.background);
        if (object.border != null) message.border = String(object.border);
        if (object.severity != null) message.severity = object.severity | 0;
        if (object.isDown != null) message.isDown = Boolean(object.isDown);
        if (object.viewType != null) message.viewType = String(object.viewType);
        return message;
      };

      /**
       * Creates a plain object from a Config message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.Config
       * @static
       * @param {network.monitor.Config} message Config
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Config.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.background = "";
          object.border = "";
          object.severity = 0;
          object.isDown = false;
          object.viewType = "";
        }
        if (message.background != null && message.hasOwnProperty("background"))
          object.background = message.background;
        if (message.border != null && message.hasOwnProperty("border"))
          object.border = message.border;
        if (message.severity != null && message.hasOwnProperty("severity"))
          object.severity = message.severity;
        if (message.isDown != null && message.hasOwnProperty("isDown"))
          object.isDown = message.isDown;
        if (message.viewType != null && message.hasOwnProperty("viewType"))
          object.viewType = message.viewType;
        return object;
      };

      /**
       * Converts this Config to JSON.
       * @function toJSON
       * @memberof network.monitor.Config
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Config.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for Config
       * @function getTypeUrl
       * @memberof network.monitor.Config
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      Config.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.Config";
      };

      return Config;
    })();

    monitor.Alert = (function () {
      /**
       * Properties of an Alert.
       * @memberof network.monitor
       * @interface IAlert
       * @property {string|null} [triggerid] Alert triggerid
       * @property {number|null} [severity] Alert severity
       * @property {string|null} [description] Alert description
       * @property {number|Long|null} [lastchange] Alert lastchange
       * @property {string|null} [hostid] Alert hostid
       * @property {string|null} [eventid] Alert eventid
       * @property {string|null} [event_name] Alert event_name
       * @property {string|null} [itemid] Alert itemid
       * @property {string|null} [key_] Alert key_
       * @property {boolean|null} [isNew] Alert isNew
       * @property {string|null} [elementId] Alert elementId
       */

      /**
       * Constructs a new Alert.
       * @memberof network.monitor
       * @classdesc Represents an Alert.
       * @implements IAlert
       * @constructor
       * @param {network.monitor.IAlert=} [properties] Properties to set
       */
      function Alert(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null && keys[i] !== "__proto__")
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * Alert triggerid.
       * @member {string} triggerid
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.triggerid = "";

      /**
       * Alert severity.
       * @member {number} severity
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.severity = 0;

      /**
       * Alert description.
       * @member {string} description
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.description = "";

      /**
       * Alert lastchange.
       * @member {number|Long} lastchange
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.lastchange = $util.Long
        ? $util.Long.fromBits(0, 0, false)
        : 0;

      /**
       * Alert hostid.
       * @member {string} hostid
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.hostid = "";

      /**
       * Alert eventid.
       * @member {string} eventid
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.eventid = "";

      /**
       * Alert event_name.
       * @member {string} event_name
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.event_name = "";

      /**
       * Alert itemid.
       * @member {string} itemid
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.itemid = "";

      /**
       * Alert key_.
       * @member {string} key_
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.key_ = "";

      /**
       * Alert isNew.
       * @member {boolean} isNew
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.isNew = false;

      /**
       * Alert elementId.
       * @member {string} elementId
       * @memberof network.monitor.Alert
       * @instance
       */
      Alert.prototype.elementId = "";

      /**
       * Creates a new Alert instance using the specified properties.
       * @function create
       * @memberof network.monitor.Alert
       * @static
       * @param {network.monitor.IAlert=} [properties] Properties to set
       * @returns {network.monitor.Alert} Alert instance
       */
      Alert.create = function create(properties) {
        return new Alert(properties);
      };

      /**
       * Encodes the specified Alert message. Does not implicitly {@link network.monitor.Alert.verify|verify} messages.
       * @function encode
       * @memberof network.monitor.Alert
       * @static
       * @param {network.monitor.IAlert} message Alert message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Alert.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.triggerid != null &&
          Object.hasOwnProperty.call(message, "triggerid")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.triggerid);
        if (
          message.severity != null &&
          Object.hasOwnProperty.call(message, "severity")
        )
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.severity);
        if (
          message.description != null &&
          Object.hasOwnProperty.call(message, "description")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.description);
        if (
          message.lastchange != null &&
          Object.hasOwnProperty.call(message, "lastchange")
        )
          writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.lastchange);
        if (
          message.hostid != null &&
          Object.hasOwnProperty.call(message, "hostid")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.hostid);
        if (
          message.eventid != null &&
          Object.hasOwnProperty.call(message, "eventid")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.eventid);
        if (
          message.event_name != null &&
          Object.hasOwnProperty.call(message, "event_name")
        )
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.event_name);
        if (
          message.itemid != null &&
          Object.hasOwnProperty.call(message, "itemid")
        )
          writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.itemid);
        if (message.key_ != null && Object.hasOwnProperty.call(message, "key_"))
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.key_);
        if (
          message.isNew != null &&
          Object.hasOwnProperty.call(message, "isNew")
        )
          writer.uint32(/* id 10, wireType 0 =*/ 80).bool(message.isNew);
        if (
          message.elementId != null &&
          Object.hasOwnProperty.call(message, "elementId")
        )
          writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.elementId);
        return writer;
      };

      /**
       * Encodes the specified Alert message, length delimited. Does not implicitly {@link network.monitor.Alert.verify|verify} messages.
       * @function encodeDelimited
       * @memberof network.monitor.Alert
       * @static
       * @param {network.monitor.IAlert} message Alert message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Alert.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Alert message from the specified reader or buffer.
       * @function decode
       * @memberof network.monitor.Alert
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {network.monitor.Alert} Alert
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Alert.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        if (long === undefined) long = 0;
        if (long > $Reader.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.network.monitor.Alert();
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error) break;
          switch (tag >>> 3) {
            case 1: {
              message.triggerid = reader.string();
              break;
            }
            case 2: {
              message.severity = reader.int32();
              break;
            }
            case 3: {
              message.description = reader.string();
              break;
            }
            case 4: {
              message.lastchange = reader.int64();
              break;
            }
            case 5: {
              message.hostid = reader.string();
              break;
            }
            case 6: {
              message.eventid = reader.string();
              break;
            }
            case 7: {
              message.event_name = reader.string();
              break;
            }
            case 8: {
              message.itemid = reader.string();
              break;
            }
            case 9: {
              message.key_ = reader.string();
              break;
            }
            case 10: {
              message.isNew = reader.bool();
              break;
            }
            case 11: {
              message.elementId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7, long);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Alert message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof network.monitor.Alert
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {network.monitor.Alert} Alert
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Alert.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Alert message.
       * @function verify
       * @memberof network.monitor.Alert
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Alert.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          return "maximum nesting depth exceeded";
        if (message.triggerid != null && message.hasOwnProperty("triggerid"))
          if (!$util.isString(message.triggerid))
            return "triggerid: string expected";
        if (message.severity != null && message.hasOwnProperty("severity"))
          if (!$util.isInteger(message.severity))
            return "severity: integer expected";
        if (
          message.description != null &&
          message.hasOwnProperty("description")
        )
          if (!$util.isString(message.description))
            return "description: string expected";
        if (message.lastchange != null && message.hasOwnProperty("lastchange"))
          if (
            !$util.isInteger(message.lastchange) &&
            !(
              message.lastchange &&
              $util.isInteger(message.lastchange.low) &&
              $util.isInteger(message.lastchange.high)
            )
          )
            return "lastchange: integer|Long expected";
        if (message.hostid != null && message.hasOwnProperty("hostid"))
          if (!$util.isString(message.hostid)) return "hostid: string expected";
        if (message.eventid != null && message.hasOwnProperty("eventid"))
          if (!$util.isString(message.eventid))
            return "eventid: string expected";
        if (message.event_name != null && message.hasOwnProperty("event_name"))
          if (!$util.isString(message.event_name))
            return "event_name: string expected";
        if (message.itemid != null && message.hasOwnProperty("itemid"))
          if (!$util.isString(message.itemid)) return "itemid: string expected";
        if (message.key_ != null && message.hasOwnProperty("key_"))
          if (!$util.isString(message.key_)) return "key_: string expected";
        if (message.isNew != null && message.hasOwnProperty("isNew"))
          if (typeof message.isNew !== "boolean")
            return "isNew: boolean expected";
        if (message.elementId != null && message.hasOwnProperty("elementId"))
          if (!$util.isString(message.elementId))
            return "elementId: string expected";
        return null;
      };

      /**
       * Creates an Alert message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof network.monitor.Alert
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {network.monitor.Alert} Alert
       */
      Alert.fromObject = function fromObject(object, long) {
        if (object instanceof $root.network.monitor.Alert) return object;
        if (long === undefined) long = 0;
        if (long > $util.recursionLimit)
          throw Error("maximum nesting depth exceeded");
        let message = new $root.network.monitor.Alert();
        if (object.triggerid != null)
          message.triggerid = String(object.triggerid);
        if (object.severity != null) message.severity = object.severity | 0;
        if (object.description != null)
          message.description = String(object.description);
        if (object.lastchange != null)
          if ($util.Long)
            (message.lastchange = $util.Long.fromValue(
              object.lastchange,
            )).unsigned = false;
          else if (typeof object.lastchange === "string")
            message.lastchange = parseInt(object.lastchange, 10);
          else if (typeof object.lastchange === "number")
            message.lastchange = object.lastchange;
          else if (typeof object.lastchange === "object")
            message.lastchange = new $util.LongBits(
              object.lastchange.low >>> 0,
              object.lastchange.high >>> 0,
            ).toNumber();
        if (object.hostid != null) message.hostid = String(object.hostid);
        if (object.eventid != null) message.eventid = String(object.eventid);
        if (object.event_name != null)
          message.event_name = String(object.event_name);
        if (object.itemid != null) message.itemid = String(object.itemid);
        if (object.key_ != null) message.key_ = String(object.key_);
        if (object.isNew != null) message.isNew = Boolean(object.isNew);
        if (object.elementId != null)
          message.elementId = String(object.elementId);
        return message;
      };

      /**
       * Creates a plain object from an Alert message. Also converts values to other types if specified.
       * @function toObject
       * @memberof network.monitor.Alert
       * @static
       * @param {network.monitor.Alert} message Alert
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Alert.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.triggerid = "";
          object.severity = 0;
          object.description = "";
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.lastchange =
              options.longs === String
                ? long.toString()
                : options.longs === Number
                  ? long.toNumber()
                  : long;
          } else object.lastchange = options.longs === String ? "0" : 0;
          object.hostid = "";
          object.eventid = "";
          object.event_name = "";
          object.itemid = "";
          object.key_ = "";
          object.isNew = false;
          object.elementId = "";
        }
        if (message.triggerid != null && message.hasOwnProperty("triggerid"))
          object.triggerid = message.triggerid;
        if (message.severity != null && message.hasOwnProperty("severity"))
          object.severity = message.severity;
        if (
          message.description != null &&
          message.hasOwnProperty("description")
        )
          object.description = message.description;
        if (message.lastchange != null && message.hasOwnProperty("lastchange"))
          if (typeof message.lastchange === "number")
            object.lastchange =
              options.longs === String
                ? String(message.lastchange)
                : message.lastchange;
          else
            object.lastchange =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.lastchange)
                : options.longs === Number
                  ? new $util.LongBits(
                      message.lastchange.low >>> 0,
                      message.lastchange.high >>> 0,
                    ).toNumber()
                  : message.lastchange;
        if (message.hostid != null && message.hasOwnProperty("hostid"))
          object.hostid = message.hostid;
        if (message.eventid != null && message.hasOwnProperty("eventid"))
          object.eventid = message.eventid;
        if (message.event_name != null && message.hasOwnProperty("event_name"))
          object.event_name = message.event_name;
        if (message.itemid != null && message.hasOwnProperty("itemid"))
          object.itemid = message.itemid;
        if (message.key_ != null && message.hasOwnProperty("key_"))
          object.key_ = message.key_;
        if (message.isNew != null && message.hasOwnProperty("isNew"))
          object.isNew = message.isNew;
        if (message.elementId != null && message.hasOwnProperty("elementId"))
          object.elementId = message.elementId;
        return object;
      };

      /**
       * Converts this Alert to JSON.
       * @function toJSON
       * @memberof network.monitor.Alert
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Alert.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Gets the default type url for Alert
       * @function getTypeUrl
       * @memberof network.monitor.Alert
       * @static
       * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
       * @returns {string} The default type url
       */
      Alert.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/network.monitor.Alert";
      };

      return Alert;
    })();

    return monitor;
  })();

  return network;
})());

export { $root as default };
